import { options, prevArrow, nextArrow } from "../../assets/js/global/slick-options";

jQuery('#projectsSlider').slick({
    infinite: false,
    speed: 300,
    slidesToShow: 2.5,
    slidesToScroll: 1,
    centerMode: false,
    rows: 0,
    arrows: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    responsive: [
        {
            breakpoint: 1250,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 950,
            settings: {
                slidesToShow: 1.5,
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
            }
        }
    ]
});
